import React from 'react';
import PropTypes from 'prop-types';
import { Form, Row, Col } from 'react-bootstrap';

const GeometryTypeField = ({ geojsonGeometry }) => (
  <Form.Group as={Row}>
    <Form.Label column xs={6}>
      Geometry Type
    </Form.Label>
    <Col xs={6}>
      <Form.Control name="geojsonGeometry" value={geojsonGeometry} readOnly plaintext />
    </Col>
  </Form.Group>
);

GeometryTypeField.propTypes = {
  geojsonGeometry: PropTypes.string.isRequired
};

export default GeometryTypeField;
